module.exports = __webpack_public_path__ + "static/media/ind_panoram.5d4ae0f8.png";